import React from 'react';
import Select, { selectType } from 'Components/Select';
import YearPicker from 'Components/YearPicker';
import { BOAT_TYPE_LIST, BOAT_STATUSES } from 'constants/boatApplication';
import RowsSelector from 'Components/RowsSelector';

export default function Filters({
  allRowsCount,
  selectedRowsCount,
  outCount,
  handleRowsSelect,
  rowsCount,
  handleSelectFilter,
  filterState,
  currentModelYear,
}) {
  return (
    <section className='list-scene__utility-section-wrapper'>
      <section className='list-scene__utility-section-filters-wrapper'>
        <div className='list-scene__utility-section-filters-header'>Filter</div>
        <Select
          selectionList={BOAT_STATUSES}
          handleSelect={handleSelectFilter('status')}
          placeholder='All'
          defaultItem={BOAT_STATUSES.find(item => item.value === filterState['status'])}
          label={'by Application Status'}
          itemNameIndicator='name'
          type={selectType.listFilter}
        />
        <Select
          selectionList={BOAT_TYPE_LIST}
          handleSelect={handleSelectFilter('boatType')}
          label='by Boat Type'
          placeholder='All'
          defaultItem={BOAT_TYPE_LIST.find(item => item.value === filterState['boatType'])}
          itemNameIndicator='name'
          type={selectType.listFilter}
        />
        <YearPicker
          endYear={currentModelYear + 1}
          yearPickAction={handleSelectFilter('year')}
          year={filterState.year}
          width={160}
          height={18}
        />
      </section>

      <section className='list-scene__utility-section-rows-select-wrapper'>
        <RowsSelector
          allRowsCount={allRowsCount}
          selectedRowsCount={selectedRowsCount}
          handleRowsSelect={handleRowsSelect}
        />
      </section>
    </section>
  );
}



// WEBPACK FOOTER //
// ./src/app/Scenes/BoatManufacturer/List/FiltersSection.jsx